import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sort-items" }
const _hoisted_2 = { class: "draggable" }
const _hoisted_3 = { class: "index" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 0,
  class: "id"
}

import { PropType, ref, watch } from 'vue';
import draggable from 'vuedraggable';


export default /*@__PURE__*/_defineComponent({
  __name: 'SortItems',
  props: {
  items: {
    type: Array as PropType<{ id: number; title?: string; text?: string }[]>,
    required: true,
  },
  order: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  showId: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const drag = ref<boolean>(false);
const items = ref<{ id: number; title?: string; text?: string }[]>(
  [...props.items].sort((a, b) =>
    props.order.length
      ? props.order.indexOf(a.id) - props.order.indexOf(b.id)
      : 0,
  ),
);

const dragEnd = () => {
  drag.value = false;

  const sortingOrder = items.value.map((i) => i.id);

  emit('change', sortingOrder);
};

watch(
  () => props.items,
  () => {
    items.value = [...props.items].sort((a, b) =>
      props.order.length
        ? props.order.indexOf(a.id) - props.order.indexOf(b.id)
        : 0,
    );
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(draggable), {
      modelValue: items.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((items).value = $event)),
      onStart: _cache[1] || (_cache[1] = ($event: any) => (drag.value = true)),
      onEnd: dragEnd
    }, {
      item: _withCtx(({ index, element }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1) + ".", 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(element.title || element.text), 1),
          (__props.showId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "(ID " + _toDisplayString(element.id) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})